import DriverOrders from "../DriverOrders";
import InfiniteScroll from "react-infinite-scroll-component";

const Driver = ({
  setModal,
  orders,
  total,
  hasMore,
  fetchMoreData,
  fetchData,
  height,
}) => {
  return (
    <div className="col-md-3 overflow-auto" style={{ height: height }}>
      <div className="mb-3">
        <div className="d-flex justify-content-between align-items-center px-3 py-2 bg-primary-transparent rounded border border-success border-opacity-25">
          <span className="d-block fw-medium fs-15">Drivers</span>
          <div>
            <span className="badge badge-task bg-primary">{total ?? 0}</span>
          </div>
        </div>
      </div>
      <div>
        <InfiniteScroll
          dataLength={orders.length}
          next={fetchMoreData}
          hasMore={hasMore}
          scrollableTarget="driver-scroll"
          loader={
            <div className="text-center my-3">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          }
        >
          <DriverOrders
            orders={orders}
            setModal={setModal}
            onReRender={fetchData}
          />
          {orders?.length === 0 && (
            <div className="text-center my-5">
              <img
                className="mx-auto w-50 my-5"
                src={`${process.env.REACT_APP_PUBLIC_URL}assets/images/media/backgrounds/no-content.png`}
                alt="no-content"
              />
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default Driver;
